import axios from 'axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        try {
            const response = await axios.get('/refresh-token', {
                withCredentials: true, // Ensures the refresh token cookie is sent
            });

            const newAccessToken = response.data.accessToken;

            // Update the auth state with the new access token (if needed)
            setAuth((prev) => ({
                ...prev,
                accessToken: newAccessToken,
            }));

            return newAccessToken;
        } catch (error) {
            console.error("Failed to refresh token:", error);
            throw error;
        }
    };

    return refresh;
};

export default useRefreshToken;